import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { motion } from "framer-motion";

import { getNetworks } from "../../redux/actions";
import ConnectWalletModal from "../reusables/modal/ConnectWalletModal";
import CustomLoader from "../CustomLoader";
import {
  ModalContent,
  ModalTitle,
  SearchInput,
  NetworksGrid,
  NetworkItem,
  NetworkIcon,
  NetworkName,
} from "./style";

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const SelectNetwork = ({ connectToNetwork, currentTheme }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const supportedNetworks = useSelector(
    (state) => state.networks.supportedNetworks
  );
  const gettingNetworks = useSelector(
    (state) => state.networks.gettingNetworks
  );

  useEffect(() => {
    dispatch(getNetworks());
  }, []);

  const filteredNetworks = supportedNetworks.filter((network) =>
    network.chainName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <ConnectWalletModal>
      <img
        style={{ width: "10%" }}
        src={
          currentTheme === "light"
            ? "/assets/img/PNG/mitterpay_logo_light.png"
            : "/assets/img/PNG/mitter_logo.png"
        }
        alt="logo"
      />
      <ModalContent>
        <ModalTitle>Connect Wallet</ModalTitle>
        <p style={{ color: theme.black, marginBottom: "10px" }}>
          Select the Network to connect
        </p>

        <SearchInput
          type="text"
          placeholder="Search networks..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {gettingNetworks ? (
          <CustomLoader />
        ) : (
          <NetworksGrid>
            {filteredNetworks.map((network, index) => (
              <NetworkItem
                key={network.chainId}
                variants={itemVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
                transition={{ duration: 0.3, delay: index * 0.05 }}
                onClick={() => connectToNetwork(network)}
              >
                <NetworkIcon src={network.image} alt={network.chainName} />
                <NetworkName>{network.chainName}</NetworkName>
              </NetworkItem>
            ))}
          </NetworksGrid>
        )}
      </ModalContent>
    </ConnectWalletModal>
  );
};

export default SelectNetwork;
